export const BACKUP_TYPE = {
  BACKUP:   'backup',
  SNAPSHOT: 'snapshot'
};

export const NETWORK_TYPE = {
  L2VLAN:       'L2VlanNetwork',
  UNTAGGED:     'UntaggedNetwork',
  OVERLAY:      'OverlayNetwork',
  L2TRUNK_VLAN: 'L2VlanTrunkNetwork',
};

export const VOLUME_MODE = {
  BLOCK:       'Block',
  FILE_SYSTEM: 'Filesystem'
};

export const ACCESS_MODE = {
  READ_WRITE_MANY:     'ReadWriteMany',
  READ_WRITE_ONCE:     'ReadWriteOnce',
  READ_ONLY_MANY:      'ReadOnlyMany',
  READ_WRITE_ONCE_POD: 'ReadWriteOncePod',
};

export const NETWORK_PROTOCOL = {
  IPv4: 'IPv4',
  IPv6: 'IPv6',
};

export const INTERNAL_STORAGE_CLASS = {
  VMSTATE_PERSISTENCE: 'vmstate-persistence',
  LONGHORN_STATIC:     'longhorn-static',
};

export const L2VLAN_MODE = {
  ACCESS: 'access',
  TRUNK:  'trunk',
};

export const VMIMPORT_SOURCE_PROVIDER = {
  VMWARE:    'vmware',
  OPENSTACK: 'openstack',
  OVA:       'ova',
};

export const VMIMPORT_SOURCE_KINDS = {
  VMWARE:    'VmwareSource',
  OPENSTACK: 'OpenstackSource',
  OVA:       'OvaSource',
};

export const CDI_POPULATOR_KIND = {
  VOLUME_IMPORT_SOURCE: 'VolumeImportSource',
  VOLUME_CLONE_SOURCE:  'VolumeCloneSource',
};

export const FILESYSTEM_SOURCE_TYPE = {
  CONFIGMAP:      'configmap',
  SECRET:         'secret',
  SERVICEACCOUNT: 'serviceaccount',
};
